import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Obtenemos el idioma almacenado en localStorage (si existe), o usamos "en" por defecto
const storedLanguage = localStorage.getItem("lang") || "es";

const resources = {
  en: {
    translation: {
      // General
      welcome: "Welcome, {{name}}",
      scheduleForm: "Schedule Form",
      clientSignature: "Client Signature",
      deleteSignature: "Delete Signature",
      menu: "Menu",
      Schedule: "Schedule",
      Inventory: "Inventory",
      "Services Manager": "Services Manager",
      Cotizaciones: "Quotations",
      "Questions List": "Questions List",
      Dashboard: "Dashboard",
      "Services Dashboard": "Services Dashboard",
      "Status Dashboard": "Status Dashboard",
      "User List": "User List",
      Clients: "Clients",
      Logout: "Logout",
      Back: "Back",
      Next: "Next",
      "New Schedule": "New Schedule",
      month: "Month",
      week: "Week",
      day: "Day",
      errorFetchingHolidays: "Error fetching holidays:",

      // ExpandedRowContent
      location: "Location",
      address: "Address",
      building: "Building",
      elevatorId: "Elevator ID",
      capacity: "Capacity",
      kg: "kg",
      operational: "Operational",
      maintenance: "Maintenance",
      out_of_service: "Out of Service",

      // UserList
      searchUsers: "Search users...",
      exportCSV: "Export CSV",
      exportPDF: "Export PDF",
      createUser: "Create User",
      actions: "Actions",
      edit: "Edit",
      uploadSignature: "Upload Signature",
      drawSignature: "Draw Signature",
      drawSignatureFor: "Draw Signature for {{name}}",
      cancel: "Cancel",
      clear: "Clear",
      saveSignature: "Save Signature",

      // UserManagement
      editUser: "Edit User",
      createNewUser: "Create New User",
      email: "Email",
      name: "Name",
      document: "Document",
      password: "Password",
      role: "Role",
      user: "User",
      admin: "Admin",
      updateUser: "Update User",
      errorFetchingUser: "Error fetching user",
      userUpdatedSuccessfully: "User updated successfully!",
      userCreatedSuccessfully: "User created successfully!",

      // ClientList
      searchClients: "Search clients...",
      createClient: "Create Client",
      previous: "Previous",
      next: "Next",
      show: "Show",
      page: "Page",
      of: "of",

      // ClientManagement / ScheduleForm
      clientManagementTitleEdit: "Edit Client",
      clientManagementTitleCreate: "Create New Client",
      phone: "Phone",
      locationName: "Location Name",
      buildingName: "Building Name",
      numberOfFloors: "Number of Floors",
      elevatorIdentifier: "Elevator Identifier",
      capacityKg: "Capacity (kg)",
      outOfService: "Out of Service",
      addElevator: "Add Elevator",
      addBuilding: "Add Building",
      addLocation: "Add Location",
      updateClient: "Update Client",
      createClient: "Create Client",
      clientUpdatedSuccessfully: "Client updated successfully!",
      clientCreatedSuccessfully: "Client created successfully!",

      // ScheduleForm
      serviceStarted: "Service Started",
      serviceCompleted: "Service Completed",
      editSchedule: "Edit Schedule",
      newSchedule: "New Schedule",
      selectUser: "Select User",
      client: "Client",
      selectClient: "Select Client",
      serviceType: "Service Type",
      selectType: "Select type",
      selectLocation: "Select Location",
      selectBuilding: "Select Building",
      selectElevator: "Select Elevator",
      startTime: "Start Time",
      endTime: "End Time",
      materialsNeeded: "Materials Needed",
      available: "Available",
      quantityFor: "Quantity for",
      remove: "Remove",
      description: "Description",
      enterScheduleDescription: "Enter schedule description",
      deleteSchedule: "Delete Schedule",
      updateSchedule: "Update Schedule",
      createSchedule: "Create Schedule",

      // ScheduleDetails
      scheduleDetails: "Schedule Details",
      clientInformation: "Client Information",

      // ChecklistSection
      checklist: "Checklist",
      estado: "Status",
      addNotesPlaceholder: "Add notes...",
      enterValuePlaceholder: "Enter value...",
      saveAllNotes: "Save All Notes",
      group: "Group",

      // AdminViewToggle
      viewDetails: "View Details",
      backToForm: "Back to Form",

      // PhotoSection
      servicePhotos: "Service Photos",
      uploadPhotos: "Upload Photos",

      // SignatureSection
      saveInformation: "Save Information",
      startService: "Start Service",
      completeService: "Complete Service",
      serviceCompleted: "Service Completed",
      personName: "Person Name",

      // InventoryList
      searchMaterials: "Search materials...",
      addMaterial: "Add Material",
      editMaterial: "Edit Material",
      addNewMaterial: "Add New Material",
      code: "Code",
      type: "Type",
      quantity: "Quantity",
      minimum_quantity: "Minimum Quantity",
      lowStock: "Low Stock",
      inStock: "In Stock",

      // Filtros y acciones adicionales
      filterByType: "Filter by Type",
      allTypes: "All Types",
      active: "Active",
      update: "Update",
      create: "Create",

      // ServiceOfferingsManager
      manageServiceOfferings: "Manage Service Offerings",
      addNewService: "Add New Service",
      editServiceOffering: "Edit Service Offering",
      newServiceOffering: "New Service Offering",
      buttonText: "Button Text",
      addBenefit: "Add Benefit",
      add: "Add",
      create: "Create",

      // QuotationForm
      quotationDetails: "Quotation Details",
      directedTo: "Directed to",
      recipient: "Recipient",
      recipientName: "Recipient Name",
      recipientRole: "Recipient Role",
      serviceTitle: "Service Title",
      technicalReport: "Technical Report",
      uploadDescriptionImage: "Upload Description Image",
      uploadImage: "Upload Image",
      paymentMethod: "Payment Method",
      warranty: "Warranty",
      fabricationTime: "Fabrication Time",
      executionTime: "Execution Time",
      closingRemarks: "Closing Remarks",
      contactName: "Contact Name",
      contactRole: "Contact Role",
      quotation: "Quotation",
      generatePDF: "Generate PDF",
      searchQuestions: "Search questions...",
      createQuestion: "Create question",
      question: "Question",
      order: "Order",
      inputType: "Input type",
      status: "Status",
      serviceTypeDistribution: "Service Type Distribution",
      allTime: "All Time",
      year: "Year",
      // Nuevos estados de servicio para ascensor, planta eléctrica y puerta vehicular
      preventivo_ascensor: "Elevator Preventive",
      correctivo_ascensor: "Elevator Corrective",
      instalacion_ascensor: "Elevator Installation",
      preventivo_planta_electrica: "Electric Plant Preventive",
      correctivo_planta_electrica: "Electric Plant Corrective",
      instalacion_planta_electrica: "Electric Plant Installation",
      preventivo_puerta_vehicular: "Vehicular Door Preventive",
      correctivo_puerta_vehicular: "Vehicular Door Corrective",
      instalacion_puerta_vehicular: "Vehicular Door Installation",
      preventivo_escalera_electrica: "Escalator Preventive",
      correctivo_escalera_electrica: "Escalator Corrective",
      instalacion_escalera_electrica: "Escalator Installation",

      electric_plant_label: "Electric Plant",
      vehicular_door_label: "Vehicular Door",
      scheduleStatusDistribution: "Schedule Status Distribution",
      pending: "Pending",
      assigned: "Assigned",
      in_progress: "In Progress",
      completed: "Completed",
      out_of_service: "Out of Service",
      "No Image": "No Image",
      photo: "Photo",
      deleteUserConfirmation: "Are you sure? You are going to delete the user",
      delete: "Delete",
      quotationNumber: "Quotation number",
      offerValidity: "Offer validity",
      signature: "Signature",

      // ReportsList
      Reports: "Reports",
      servicesReport: "Services Report",
      dateFrom: "From",
      dateTo: "To",
      thisMonth: "This month",
      lastMonth: "Last month",
      thisYear: "This year",
      refresh: "Refresh",
      serviceCategory: "Service Category",
      categoryPreventive: "Preventive",
      categoryCorrective: "Corrective",
      categoryInstallation: "Installation",
      allServiceTypes: "All service types",
      allCategories: "All categories",
      allStatuses: "All statuses",
      searchServices: "Search by client, technician or description...",
      totalServices: "Total services",
      scheduledDate: "Scheduled Date",
      technician: "Technician",
      durationHours: "Duration (h)",
      workDone: "Work Done",
      observations: "Observations",
      receivedBy: "Received By",
      elevator: "Elevator",
      includeFullDetail: "Include full detail",
      includeFullDetailHelp:
        "Adds site, building, elevator, actual times, work done and observations. Requires one request per service, so the export takes longer.",
      exportExcel: "Export Excel",
      loadingDetails: "Loading detail",
      noResults: "No services found for these filters",
      reportLoadError: "Error loading the report",
    },
  },
  es: {
    translation: {
      // General
      welcome: "Bienvenido, {{name}}",
      scheduleForm: "Formulario de Agenda",
      clientSignature: "Firma del Cliente",
      deleteSignature: "Eliminar Firma",
      menu: "Menú",
      Schedule: "Agenda",
      Inventory: "Inventario",
      "Services Manager": "Gestor de Servicios",
      Cotizaciones: "Cotizaciones",
      "Questions List": "Lista de Preguntas",
      Dashboard: "Panel de Control",
      "Services Dashboard": "Panel de Servicios",
      "Status Dashboard": "Panel de Estado",
      "User List": "Lista de Usuarios",
      Clients: "Clientes",
      Logout: "Cerrar Sesión",
      Back: "Atrás",
      Next: "Siguiente",
      "New Schedule": "Nueva Agenda",
      month: "Mes",
      week: "Semana",
      day: "Día",
      errorFetchingHolidays: "Error al obtener los días festivos:",

      // ExpandedRowContent
      location: "Ubicación",
      address: "Dirección",
      building: "Edificio",
      elevatorId: "ID de Ascensor",
      capacity: "Capacidad",
      kg: "kg",
      operational: "Operativo",
      maintenance: "Mantenimiento",
      out_of_service: "Fuera de Servicio",

      // UserList
      searchUsers: "Buscar usuarios...",
      exportCSV: "Exportar CSV",
      exportPDF: "Exportar PDF",
      createUser: "Crear Usuario",
      actions: "Acciones",
      edit: "Editar",
      uploadSignature: "Subir Firma",
      drawSignature: "Dibujar Firma",
      drawSignatureFor: "Dibujar Firma para {{name}}",
      cancel: "Cancelar",
      clear: "Limpiar",
      saveSignature: "Guardar Firma",

      // UserManagement
      editUser: "Editar Usuario",
      createNewUser: "Crear Nuevo Usuario",
      email: "Correo",
      name: "Nombre",
      document: "Documento",
      password: "Contraseña",
      role: "Rol",
      user: "Usuario",
      admin: "Administrador",
      updateUser: "Actualizar Usuario",
      errorFetchingUser: "Error al obtener el usuario",
      userUpdatedSuccessfully: "¡Usuario actualizado con éxito!",
      userCreatedSuccessfully: "¡Usuario creado con éxito!",

      // ClientList
      searchClients: "Buscar clientes...",
      createClient: "Crear Cliente",
      previous: "Anterior",
      next: "Siguiente",
      show: "Mostrar",
      page: "Página",
      of: "de",

      // ClientManagement / ScheduleForm
      clientManagementTitleEdit: "Editar Cliente",
      clientManagementTitleCreate: "Crear Nuevo Cliente",
      phone: "Teléfono",
      locationName: "Nombre de Ubicación",
      buildingName: "Nombre de Edificio",
      numberOfFloors: "Número de Pisos",
      elevatorIdentifier: "Identificador de Ascensor",
      capacityKg: "Capacidad (kg)",
      outOfService: "Fuera de Servicio",
      addElevator: "Agregar Ascensor",
      addBuilding: "Agregar Edificio",
      addLocation: "Agregar Ubicación",
      updateClient: "Actualizar Cliente",
      createClient: "Crear Cliente",
      clientUpdatedSuccessfully: "¡Cliente actualizado con éxito!",
      clientCreatedSuccessfully: "¡Cliente creado con éxito!",

      // ScheduleForm
      serviceStarted: "Servicio Iniciado",
      serviceCompleted: "Servicio Completado",
      editSchedule: "Editar Agenda",
      newSchedule: "Nueva Agenda",
      selectUser: "Seleccione Usuario",
      client: "Cliente",
      selectClient: "Seleccione Cliente",
      serviceType: "Tipo de Servicio",
      selectType: "Seleccione tipo",
      selectLocation: "Seleccione Ubicación",
      selectBuilding: "Seleccione Edificio",
      selectElevator: "Seleccione Ascensor",
      startTime: "Hora de Inicio",
      endTime: "Hora de Finalización",
      materialsNeeded: "Materiales Necesarios",
      available: "Disponibles",
      quantityFor: "Cantidad para",
      remove: "Eliminar",
      description: "Descripción",
      enterScheduleDescription: "Ingrese descripción de la agenda",
      deleteSchedule: "Eliminar Agenda",
      updateSchedule: "Actualizar Agenda",
      createSchedule: "Crear Agenda",

      // ScheduleDetails
      scheduleDetails: "Detalles de la Agenda",
      clientInformation: "Información del Cliente",

      // ChecklistSection
      checklist: "Checklist",
      estado: "Estado",
      addNotesPlaceholder: "Agregar notas...",
      enterValuePlaceholder: "Ingrese valor...",
      saveAllNotes: "Guardar todas las notas",
      group: "Grupo",

      // AdminViewToggle
      viewDetails: "Ver Detalles",
      backToForm: "Volver al Formulario",

      // PhotoSection
      servicePhotos: "Fotos del Servicio",
      uploadPhotos: "Subir Fotos",

      // SignatureSection
      saveInformation: "Guardar Información",
      startService: "Iniciar Servicio",
      completeService: "Completar Servicio",
      serviceCompleted: "Servicio Completado",
      personName: "Nombre de Persona",

      // InventoryList
      searchMaterials: "Buscar materiales...",
      addMaterial: "Agregar Material",
      editMaterial: "Editar Material",
      addNewMaterial: "Agregar Nuevo Material",
      code: "Código",
      type: "Tipo",
      quantity: "Cantidad",
      minimum_quantity: "Cantidad Mínima",
      lowStock: "Stock Bajo",
      inStock: "En Stock",

      // Filtros y acciones adicionales para inventario
      filterByType: "Filtrar por Tipo",
      allTypes: "Todos los Tipos",
      active: "Activo",
      update: "Actualizar",
      create: "Crear",

      // ServiceOfferingsManager
      manageServiceOfferings: "Administrar Ofertas de Servicio",
      addNewService: "Agregar Nuevo Servicio",
      editServiceOffering: "Editar Oferta de Servicio",
      newServiceOffering: "Nueva Oferta de Servicio",
      buttonText: "Texto del Botón",
      addBenefit: "Agregar Beneficio",
      add: "Agregar",
      create: "Crear",

      // QuotationForm
      quotationDetails: "Detalles de la Cotización",
      directedTo: "Dirigido a",
      recipient: "Destinatario",
      recipientName: "Nombre del Destinatario",
      recipientRole: "Cargo del Destinatario",
      serviceTitle: "Título del Servicio",
      technicalReport: "Informe Técnico",
      uploadDescriptionImage: "Subir Imagen de Descripción",
      uploadImage: "Subir Imagen",
      paymentMethod: "Forma de Pago",
      warranty: "Garantía",
      fabricationTime: "Tiempo de Fabricación",
      executionTime: "Tiempo de Ejecución",
      closingRemarks: "Observaciones Finales",
      contactName: "Nombre de Contacto",
      contactRole: "Cargo de Contacto",
      quotation: "Cotización",
      generatePDF: "Generar PDF",
      searchQuestions: "Buscar preguntas...",
      createQuestion: "Crear Pregunta",
      question: "Pregunta",
      order: "Orden",
      inputType: "Tipo de Entrada",
      status: "Estado",
      serviceTypeDistribution: "Distribución de Tipos de Servicio",
      allTime: "Todo el Tiempo",
      year: "Año",
      // Nuevos estados de servicio para ascensor, planta eléctrica y puerta vehicular
      preventivo_ascensor: "Preventivo Ascensor",
      correctivo_ascensor: "Correctivo Ascensor",
      instalacion_ascensor: "Instalación Ascensor",
      preventivo_planta_electrica: "Preventivo Planta Eléctrica",
      correctivo_planta_electrica: "Correctivo Planta Eléctrica",
      instalacion_planta_electrica: "Instalación Planta Eléctrica",
      preventivo_puerta_vehicular: "Preventivo Puerta Vehicular",
      correctivo_puerta_vehicular: "Correctivo Puerta Vehicular",
      instalacion_puerta_vehicular: "Instalación Puerta Vehicular",
      preventivo_escalera_electrica: "Preventivo Escalera Eléctrica",
      correctivo_escalera_electrica: "Correctivo Escalera Eléctrica",
      instalacion_escalera_electrica: "Instalación Escalera Eléctrica",

      electric_plant_label: "Planta Eléctrica",
      vehicular_door_label: "Puerta Vehicular",
      scheduleStatusDistribution: "Distribución del Estado de Agendas",
      pending: "Pendiente",
      assigned: "Asignado",
      in_progress: "En Progreso",
      completed: "Completado",
      out_of_service: "Fuera de servicio",
      "No Image": "Sin imagen",
      photo: "Foto",
      deleteUserConfirmation: "¿Estás seguro? Se eliminará el usuario",
      delete: "Eliminar",
      quotationNumber: "Número de cotización",
      offerValidity: "Vigencia de la oferta",
      signature: "Firma",

      // ReportsList
      Reports: "Informes",
      servicesReport: "Informe de Servicios",
      dateFrom: "Desde",
      dateTo: "Hasta",
      thisMonth: "Este mes",
      lastMonth: "Mes anterior",
      thisYear: "Este año",
      refresh: "Actualizar",
      serviceCategory: "Clase de Servicio",
      categoryPreventive: "Preventivo",
      categoryCorrective: "Correctivo",
      categoryInstallation: "Instalación",
      allServiceTypes: "Todos los tipos",
      allCategories: "Todas las clases",
      allStatuses: "Todos los estados",
      searchServices: "Buscar por cliente, técnico o descripción...",
      totalServices: "Total de servicios",
      scheduledDate: "Fecha Programada",
      technician: "Técnico",
      durationHours: "Duración (h)",
      workDone: "Trabajos Realizados",
      observations: "Observaciones",
      receivedBy: "Recibido Por",
      elevator: "Ascensor",
      includeFullDetail: "Incluir detalle completo",
      includeFullDetailHelp:
        "Agrega sede, edificio, ascensor, horas reales, trabajos realizados y observaciones. Requiere una consulta por servicio, así que la exportación demora más.",
      exportExcel: "Exportar Excel",
      loadingDetails: "Cargando detalle",
      noResults: "No hay servicios para estos filtros",
      reportLoadError: "Error al cargar el informe",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const switchLanguage = (language) => {
  localStorage.setItem("lang", language);
  i18n.changeLanguage(language);
};

export default i18n;
